import React from 'react';

/**
 * AeroPlanMeter: the plan name, "N of M" and a thin meter, labelled "Test
 * sessions used" (never "a month": sessions are counted as stored, see
 * docs/brand/PRICING-FACTS.md). Sits above the account in the sidebar; in the
 * icon rail only the meter line shows. Flat v3 styles: .aero-plan-* in
 * aero-ut-theme.css (render inside .ut-theme).
 *
 * Props: plan ('Free plan'), used (number or null while counting), limit,
 * onClick (optional: the whole block becomes a button).
 */
export default function AeroPlanMeter({ plan, used = null, limit = null, onClick, className = '' }) {
  const known = typeof used === 'number' && typeof limit === 'number' && limit > 0;
  const pct = known ? Math.min(100, Math.round((used / limit) * 100)) : 0;
  const full = known && used >= limit;
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag
      type={onClick ? 'button' : undefined}
      className={`aero-plan ${full ? 'is-full' : ''} ${className}`.trim()}
      onClick={onClick}
      title={known ? `${plan}: ${used} of ${limit} test sessions used` : plan}
    >
      <span className="aero-plan-head">
        <span>{plan}</span>
        {known && <span className="aero-plan-count">{used} of {limit}</span>}
      </span>
      <i className="aero-plan-meter" aria-hidden="true"><b style={{ width: `${pct}%` }} /></i>
      <small className="aero-plan-label">Test sessions used</small>
    </Tag>
  );
}
